/**
 * Ступени программы глазами ученика: короткое имя и что на ней умеешь.
 * Один источник для итога теста, дашборда и профиля.
 */

import type { CurriculumLevel } from '@aptile/shared';

import i18n from '../i18n';

export function levelStep(level: CurriculumLevel): number {
  return LEVEL_ORDER.indexOf(level) + 1;
}

export const LEVEL_COUNT = 5;

const LEVEL_ORDER: readonly CurriculumLevel[] = ['A1', 'A2', 'B1', 'B2', 'C1'];

function known(code: string): CurriculumLevel {
  return LEVEL_ORDER.find((level) => level === code) ?? 'C1';
}

/**
 * Название ступени для ученика на языке интерфейса («Старт», «Start»…).
 * Вызывать при отрисовке, а не в константах модуля: язык может смениться.
 */
export function levelName(code: string): string {
  return i18n.t(`levels.${known(code)}.name`);
}

/** Что ученик умеет на ступени — одной фразой. */
export function levelCanDo(code: string): string {
  return i18n.t(`levels.${known(code)}.canDo`);
}
